import delivery from './../videos/delivery.webm';
import spring from './../videos/spring.webm';
import video_python from './../videos/video_python.webm';
import blog from './../videos/blog.webm';
import cashback from './../videos/cashback.webm';
import laravel from './../videos/laravel.webm';
import covid from './../videos/covid.webm';
import qrcode from './../videos/qrcode.webm';
import tech from './../videos/tech-news.webm';
import pokedex from './../videos/pokedex.webm';
import conta from './../videos/conta.webm';
import quizz from './../videos/quizz.webm';
import python from './../videos/python.webm';
import calculadora from './../videos/calculadora.webm';
import trybe from './../videos/trybe-futebom.webm';
import Books from './../videos/Books.webm';



const videos = [
  {
    id: 1,
    title: 'Delivery app',
    video: delivery,
  },
  {
    id: 2,
    title: 'Spring boot',
    video: spring,
  },
  {
    id: 3,
    title: 'Flask app',
    video: video_python,
  },
  {
    id: 4,
    title: 'Laravel app',
    video: laravel,
  },
  {
    id: 5,
    title: 'Blog app',
    video: blog,
  },
  {
    id: 6,
    title: 'Tech',
    video: tech,
  },
  {
    id: 7,
    title: 'Covid Systems',
    video: covid,
  },
  {
    id: 8,
    title: 'Qrcode Application',
    video: qrcode,
  },
  {
    id: 9,
    title: 'Cashback',
    video: cashback,
  },
  {
    id: 10,
    title: 'Pokedex',
    video: pokedex,
  },
  {
    id: 11,
    title: 'Conta',
    video: conta,
  },
  {
    id: 12,
    title: 'Quizz',
    video: quizz,
  },
  {
    id: 13,
    title: 'Flask python',
    video: python,
  },
  {
    id: 14,
    title: 'Calculadora',
    video: calculadora,
  },
  {
    id: 16,
    title: 'Trybe futebol',
    video: trybe,
  },
  {
    id: 17,
    title: 'Books',
    video: Books,
  }
]

export default videos;